import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useEffect, useState } from 'react';
import { Textarea as ChakraTextarea } from '@chakra-ui/react';
const TextareaFC = ({ rows, value, disabled, size = 'xs', variant = 'outline', isOnChangeOnlyOnBlur, onChange, onBlur }) => {
    const [inputValue, setInputValue] = useState('');
    useEffect(() => {
        setInputValue(value ?? '');
    }, [value]);
    return (_jsx(ChakraTextarea, { size: size, rows: rows, variant: variant, value: inputValue, disabled: disabled, onChange: (event) => {
            setInputValue(event.target.value);
            if (!isOnChangeOnlyOnBlur) {
                onChange?.(event.target.value);
            }
        }, onBlur: (event) => {
            if (isOnChangeOnlyOnBlur) {
                onChange?.(event.target.value);
            }
            onBlur?.(event.target.value);
        } }));
};
export const Textarea = memo(TextareaFC);
//# sourceMappingURL=Textarea.js.map